import { deepmerge } from "@mui/utils";
import { radiantLightTheme, radiantDarkTheme, type RaThemeOptions } from "react-admin";

const FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif";

const shared: RaThemeOptions = {
  typography: {
    fontFamily: FONT,
    h6: { fontWeight: 700, letterSpacing: "-0.01em" },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: "none", borderRadius: 10, fontWeight: 600 } },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiCard: { styleOverrides: { root: { borderRadius: 16 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600, borderRadius: 8 } } },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, fontSize: "0.8rem", letterSpacing: "0.01em", color: "text.secondary" },
      },
    },
    MuiTextField: { defaultProps: { variant: "outlined" } },
    MuiAppBar: {
      styleOverrides: { root: { boxShadow: "none", borderBottom: "1px solid rgba(0,0,0,0.06)" } },
    },
  },
};

export const lightTheme = deepmerge(
  radiantLightTheme,
  deepmerge(shared, {
    palette: {
      mode: "light",
      primary: { main: "#4f46e5" },
      secondary: { main: "#0ea5e9" },
      background: { default: "#f4f5f7", paper: "#ffffff" },
    },
  }),
);

export const darkTheme = deepmerge(
  radiantDarkTheme,
  deepmerge(shared, {
    palette: {
      mode: "dark",
      primary: { main: "#818cf8" },
      secondary: { main: "#38bdf8" },
      background: { default: "#0f1115", paper: "#171a21" },
    },
  }),
);
